<template>
  <div class="col-lg-10 col-12">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header border-0">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="mb-0">Bookings</h3>
              </div>
            </div>
          </div>

          <div class="col-12" v-if="this.items == null && !this.loaded">
            <p><em>Loading...</em></p>
          </div>
          <div class="col-12" v-else>
            <div class="col-12">
              <div class="row">
                <div class="card-body">
                  <!-- list -->
                  <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                      <tr>
                        <th class="col-auto">Date</th>
                        <th class="col-1">Seat</th>

                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in this.items" :key="index">
                        <td>
                          <p class="booking-reference">
                            Reservation reference: <span>{{ item.bookingReference }}</span>
                          </p>
                          {{ item.date | dateFilterFormatUKEventDisplay }}
                        </td>

                        <td>
                          <span class="seat-code">{{ item.bookedSeat.seat.code }}</span>
                        </td>
                        <td>
                          <!-- <div class="d-none d-sm-block">
                            <a class="app-btn app-btn-primary app-btn-sm margin-right-5" href="">edit</a>
                          </div> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-12">
                <!-- <RbPager Pager=@_pager RouteName="@RouteName"
                         OnPageChanged="(async (e) => { _currentPage = e; await GetData();})" /> -->
              </div>
            </div>
          </div>
          <div class="">
            <!--col-12 -->
            <div class="card-footer">
              <div class="navigation-buttons">
                <button type="button" class="btn btn-primary" v-on:click="goBack()"><i class="fas fa-chevron-left"></i> Back</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { BookingService } from "@/services/ApiService";
import GenericDialog from "@/components/controls/GenericDialog.vue";
import dateFilter from "@/filters/dateFilter";
import dateFilterFormatUKEventDisplay from "@/filters/dateFilterFormatUKEventDisplay";
import timeFilter from "@/filters/timeFilter";
import commonMixin from "@/mixins/commonMixin";
import { toastNotificationComputed, toastNotificationMethods, toastNotificationMutations } from "@/state/helpers";

export default {
  name: "UserBookings",
  filters: { dateFilter, timeFilter, dateFilterFormatUKEventDisplay },
  mixins: [commonMixin],
  components: {
    GenericDialog
  },
  data() {
    return {
      items: null,
      selectedEvent: {},
      showGenericDeleteDialog: false,
      genericDialogContent: "",
      bookingId: "",
      seatBookingId: "",
      loaded: false
    };
  },
  methods: {
    goBack() {
        this.$router.push({ path: "/my-account" });
    },
    async loadData() {
      var response = await BookingService.getAllBookedSeatsByUser();
      if (typeof response !== "undefined" && response.success && typeof response.data !== "undefined") {
        //this.selectedEvent = response.data.selectedEvent;
        this.items = response.data;
        this.loaded = true;
      }
    }
  },
  async mounted() {
    await this.loadData();
  },
  created() {}
};
</script>

<style lang="scss" scoped>
</style>